Ext.define('SA.view.FormattedNumberField', {
    alias: 'widget.sa-formatted-numberfield',
    extend: 'SA.view.TextField',

    enforceMaxLength: true,
    maxLength: 24,
    maxValue: 1e12,
    minValue: -1e12,

    beforeBlur() {
        this.setValue(this.rawToValue(this.getRawValue()));
    },

    beforeRender() {
        this.addCls('sa-numberfield');
        this.callParent();
    },

    format: Ext.identityFn,

    parseValue : function(value) {
        var min = this.minValue,
            max = this.maxValue;

        value = parseFloat((value + '').replace(/[^\d\.\-]/g, ''));

        if (Ext.isNumber(min)) {
            value = Math.max(min, value);
        }

        if (Ext.isNumber(max)) {
            value = Math.min(max, value);
        }

        return isNaN(value) ? null : value;
    },

    rawToValue(rawValue) {
        return this.parseValue(rawValue);
    },

    setFormat(fn) {
        this.format = fn;

        this.setValue(this.getValue());
    },

    setValueUnevented(value) {
        this.suspendEvent('change');
        this.setValue(value);
        this.resumeEvent('change');
    },

    valueToRaw(value) {
        value = this.parseValue(value);

        if (value === null) {
            return '';
        }

        return this.format(value);
    }
});